// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"7729":"player.js","7967":"three.js","8974":"fixOrientation","9813":"hls.js"}[chunkId] || chunkId) + ".min.js";
};